module.exports = __webpack_public_path__ + "media/images/157x162_shadow-28e0afbc7e9dd59687301964c8c3d51c170820644d730d7473aee8f329c72448.png";